
import * as XLSX from 'xlsx';


 // have been used function in JSON for eval.(time calculation)    
 function convertToDate(dateStr) {
  const [day, month, year, hour, minute] = dateStr?.split(/[-: ]/);
  return new Date(year, month - 1, day, hour, minute);
}

  function filecellValue(arr,key) {
    if (typeof key === 'string') {
      return arr[key];
    } else if (Array.isArray(key)) {
      let value = "";
      for (const item of key) {
        if (item.column) {
          value += String(arr[item.column] || '');
        } else if (item.condition) {
          value += eval(item.condition);
        } else if (item.string) {
          value += item.string;
        }
      }
      return value;
    } else {
      return "";
    }
  }
  
  function generateXLSX(data, headers) {
    const filteredData = data.map(item =>
      headers.reduce((acc, header) => {
        let value = filecellValue(item, header.dataIndex);
        // Format value according to valueFormat
        switch (header.valueFormat) {
          case "number":
            case "currency":
              if (value !== null && value !== undefined && value !== "" && !isNaN(value)) {
                value = parseFloat(value).toFixed(header.decimalPoints || 0);
                value = Number(value); // Ensure it remains a number
              } else {
                value = ''; // Set blank for invalid or missing numbers
              }
              break;

          case "string":
            value = value ? String(value) : ''; // Ensure empty strings are handled
            break;
  
          case "date":
            value = value ? String(value) : '';
          // value = value ? new Date(value).toLocaleDateString() : ''; // Handle empty dates
            break;
  
          default:
            value = value || ''; // Default blank for undefined types
            break;
        }
  
        acc[header.title] = value;
        return acc;
      }, {})
    );
  
    // Calculate the totals for columns with `total: true`
    const totalRow = headers.reduce((acc, header, index) => {
      if (index === 0) {
        acc[header.title] = 'Total';
      } else if (header?.total) {
        let totalSum = calculateTotalSum(data, header);
        // if (header.valueFormat === "number") {
        //   totalSum = totalSum !== null && !isNaN(totalSum)
        //     ? Number(totalSum).toFixed(header.decimalPoints || 0)
        //     : ''; // Set blank if no valid total
        // }
        acc[header.title] = totalSum;
      } else {
        acc[header.title] = '';
      }
      return acc;
    }, {});

    filteredData.push(totalRow);
  
    // Create worksheet and workbook
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
  
    // Apply column formatting based on the `valueFormat`
    headers.forEach((header, colIdx) => {
      const colLetter = XLSX.utils.encode_col(colIdx);
      for (let rowIdx = 1; rowIdx <= filteredData.length; rowIdx++) {
        const cellRef = `${colLetter}${rowIdx + 1}`; // Adjust for header row
        
        if (!worksheet[cellRef]) continue;
  
        // Apply formatting based on valueFormat
        switch (header.valueFormat) {
          case "number":
            worksheet[cellRef].t = "n"; // 'n' for number
            worksheet[cellRef].z = `0.${'0'.repeat(header.decimalPoints || 0)}`; // Set decimal points
            break;
  
          case "string":
            worksheet[cellRef].t = "s"; // 's' for string
            break;

            case "currency":
              worksheet[cellRef].t = "n"; // 'n' for number
            worksheet[cellRef].z = `0.${'0'.repeat(header.decimalPoints || 0)}`; // Set decimal points
            break;
  
          case "date":
            worksheet[cellRef].t = "s"; // 's' for string
            break;
            default:
              worksheet[cellRef].t = "s"; // 's' for string
              break;
        }
      }
    });
  
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
  
    try {
      const xlsBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      return new Blob([xlsBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    } catch (error) {
      console.error("Error generating XLSX file:", error);
      throw error; // Rethrow the error to be handled by the caller
    }
  }
  
  const downloadXLSX = (data, headers, apiContextObj) => {
    try {
      const xlsBlob = generateXLSX(data, headers);
      const url = URL.createObjectURL(xlsBlob);
      const link = document.createElement('a');
  
      const filename = (apiContextObj.contextHeading|| apiContextObj.applicationContext || '').toLowerCase().replace(" ", "_") + ".xlsx";
      
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading XLSX file:", error);
    }
  };


function generateXLS(data, headers) {
  const filteredData = data.map(item =>
    headers.reduce((acc, header) => {
      let value = filecellValue(item, header.dataIndex);

      // Format value according to valueFormat
      switch (header.valueFormat) {
        case "number":
          case "currency":
            if (value !== null && value !== undefined && value !== "" && !isNaN(value)) {
              value = parseFloat(value).toFixed(header.decimalPoints || 0);
              value = Number(value); // Ensure it remains a number
            } else {
              value = ''; // Set blank for invalid or missing numbers
            }
            break;
        case "string":
          value = value ? String(value) : ''; // Ensure empty strings are handled
          break;

        case "date":
          value = value ? String(value) : '';
          // value = value ? new Date(value).toLocaleDateString() : ''; // Handle empty dates
          break;

        default:
          value = value || ''; // Default blank for undefined types
          break;
      }

      acc[header.title] = value;
      return acc;
    }, {})
  );

  // Calculate the totals for columns with `total: true`
  const totalRow = headers.reduce((acc, header, index) => {
    if (index === 0) {
      acc[header.title] = 'Total';
    } else if (header?.total) {
      let totalSum = calculateTotalSum(data, header);
    //   if (header.valueFormat === "number") {
    //     totalSum = totalSum !== null && !isNaN(totalSum)
    //       ? Number(totalSum).toFixed(header.decimalPoints || 0)
    //       : ''; // Set blank if no valid total
    //   }
      acc[header.title] = totalSum;
    } else {
      acc[header.title] = '';
    }
    return acc;
  }, {});

  filteredData.push(totalRow);

  // Create worksheet and workbook
  const worksheet = XLSX.utils.json_to_sheet(filteredData);

  // Apply column formatting and font styling based on the `valueFormat`
  headers.forEach((header, colIdx) => {
    const colLetter = XLSX.utils.encode_col(colIdx);
    for (let rowIdx = 1; rowIdx <= filteredData.length; rowIdx++) {
      const cellRef = `${colLetter}${rowIdx + 1}`; // Adjust for header row
      
      if (!worksheet[cellRef]) continue;

      // Apply formatting based on valueFormat
      switch (header.valueFormat) {
        case "number":
          case "currency":
            worksheet[cellRef].t = "n"; // 'n' for number
          worksheet[cellRef].z = `0.${'0'.repeat(header.decimalPoints || 0)}`; // Set decimal points
          break;

        case "string":
          worksheet[cellRef].t = "s"; // 's' for string
          break;

        case "date":
          worksheet[cellRef].t = "s"; // 's' for string since date formatting might cause issues in `.xls`
          break;
      }
    }
  });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');

  try {
    const xlsBuffer = XLSX.write(workbook, { bookType: 'xls', type: 'array' });
    return new Blob([xlsBuffer], { type: 'application/vnd.ms-excel' });
  } catch (error) {
    console.error("Error generating XLS file:", error);
    throw error; // Rethrow the error to be handled by the caller
  }
}

const downloadXLS = (data, headers,apiContextObj) => {
  try {
    const xlsBlob = generateXLS(data, headers);
    const url = URL.createObjectURL(xlsBlob);
    const link = document.createElement('a');

    const filename = (apiContextObj.contextHeading|| apiContextObj.applicationContext || '').toLowerCase().replace(" ", "_") + ".xls";
     
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error downloading XLS file:", error);
  }
};
  
function generateCSV(data, headers) {
    const filteredData = data.map(item =>
      headers.reduce((acc, header) => {
        let value = filecellValue(item, header.dataIndex);
  
        // Format value according to valueFormat
        switch (header.valueFormat) {
          case "number":
            case "currency":
              if (value !== null && value !== undefined && value !== "" && !isNaN(value)) {
                value = parseFloat(value).toFixed(header.decimalPoints || 0);
              } else {
                value = ''; // Set blank for invalid or missing numbers
              }
              break;
          case "string":
            value = value ? String(value) : ''; // Ensure empty strings are handled
            break;
  
          case "date":
            value = value ? String(value) : '';
            // if (value) {
            //   // Convert date to ISO string (or use any preferred format)
            //   value = new Date(value).toISOString().split('T')[0]; // Format: YYYY-MM-DD
            // } else {
            //   value = ''; // Handle empty dates
            // }
            break;
  
          default:
            value = value || ''; // Default blank for undefined types
            break;
        }
  
        acc[header.title] = value;
        return acc;
      }, {})
    );
  
    // Calculate the totals for columns with `total: true`
    const totalRow = headers.reduce((acc, header) => {
      if (header?.total) {
        let totalSum = calculateTotalSum(data, header);
        if (header.valueFormat === "number") {
          totalSum = totalSum !== null && !isNaN(totalSum)
            ? Number(totalSum).toFixed(header.decimalPoints || 0)
            : ''; // Set blank if no valid total
        }
        acc[header.title] = totalSum;
      } else {
        acc[header.title] = ''; // Empty cell if not a total column
      }
      return acc;
    }, {});
  
    // Generate CSV content
    const csvRows = [];
    const headerRow = headers.map(header => `"${header.title.replace(/"/g, '""')}"`).join(',');
    csvRows.push(headerRow);
  
    filteredData.forEach(row => {
      const values = headers.map(header => {
        let value = row[header.title];
        // Handle cases where values contain commas or quotes
        if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
          value = `"${value.replace(/"/g, '""')}"`;
        }
        return value;
      });
      csvRows.push(values.join(','));
    });
  
    // Add the totals row at the end of the CSV content
    const totalValues = headers.map(header => {
      let value = totalRow[header.title];
      // Handle cases where values contain commas or quotes
      if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
        value = `"${value.replace(/"/g, '""')}"`;
      }
      return value;
    });
    csvRows.push(totalValues.join(','));
  
    const csvContent = csvRows.join('\n');
    return new Blob([csvContent], { type: 'text/csv' });
  }
  
  const downloadCSV = (data, headers, apiContextObj) => {
    const csvBlob = generateCSV(data, headers);
    const url = URL.createObjectURL(csvBlob);
    const link = document.createElement('a');
  
    // Assuming apiContextObj.contextHeading is available
    const filename = (apiContextObj.contextHeading|| apiContextObj.applicationContext || '').toLowerCase().replace(/ /g, "_") + ".csv";
  
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  

 // Helper function to calculate the total sum for a column
function calculateTotalSum(data, header) {
  return data.reduce((sum, row) => {
    let value = filecellValue(row, header.dataIndex);
    // Convert value to a number
    let numericValue = parseFloat(value);
    // Check if the converted value is finite
    if (Number.isFinite(numericValue)) {
      return sum + numericValue;
    }
    // console.log(value);
    return sum;
  }, 0);
}
  
  
  export {downloadXLSX, downloadXLS, downloadCSV}